<template>
    <span>
        <a @click="openHelpMessageToolTip()" id="helpToolTip">Help</a>
          <b-popover  triggers="hover focus" target="helpToolTip" title="">
            <p><span class="question-mark">?</span> Use the yellow Help Icons to learn more about this website.</p>
            <p>Not every page has Help Icons. You can start on the auction search form to see example help icons.</p>
            <p>Click on the "Hide Help" link at the top of the page to hide the help icons.</p>
            <p>For more help, use the "Report problem" link at the bottom of any page to contact technical support, or use the "Contact" link to contact sales or administative staff. </p>
        </b-popover>
    </span>
</template>
<script>

    import { mapState, mapActions } from 'vuex'
    import {objLookup} from '../util/common'

    export default {

        data() {
            return {
                isToolTipActive: false,
                isVisible:false,
            }
        },
        methods: {
            openHelpMessageToolTip(){
                this.isToolTipActive = !this.isToolTipActive;
                if(this.isToolTipActive){
                    $('.show-tooltip').css('display','inline-block');
                } else{
                    $('.show-tooltip').css('display','none');
                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/HelpToolTip.vue